export const API_URL = import.meta.env.VITE_API_URL as string

export const JWT_SECRET = '123456' as string;